var _path, _path2, _path3, _line, _line2, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65685 3L5.24264 2.58579C4.46159 1.80474 3.19526 1.80474 2.41421 2.58579V2.58579C1.63316 3.36684 1.63317 4.63317 2.41421 5.41421L2.82843 5.82843",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3431 3L18.7574 2.58579C19.5384 1.80474 20.8047 1.80474 21.5858 2.58579V2.58579C22.3668 3.36684 22.3668 4.63317 21.5858 5.41421L21.1716 5.82843",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6313 14.4637L20.6336 10.3067C19.6755 6.31464 16.1054 3.5 12 3.5C7.89456 3.5 4.32449 6.31464 3.36639 10.3067L2.36872 14.4637C2.13057 15.456 2.24255 16.5079 2.85701 17.3226C4.18951 19.0894 7.12455 22 12 22C16.8755 22 19.8105 19.0894 21.143 17.3226C21.7574 16.5079 21.8694 15.456 21.6313 14.4637Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 8.75,
    x2: 8.25,
    y2: 10.25,
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.75,
    y1: 8.75,
    x2: 15.75,
    y2: 10.25,
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.5L16.1932 17.7215C17.0882 14.8873 14.9721 12 12 12V12C9.02787 12 6.91179 14.8873 7.80679 17.7215L9 21.5",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15V18L13.5 18.5",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15V18L10.5 18.5",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13C9.5 13 10 14.5 12 14.5C14 14.5 14.5 13 14.5 13",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBear);
export default __webpack_public_path__ + "static/media/bear.54b7f077974147b39ead89203164d37a.svg";
export { ForwardRef as ReactComponent };